import { render, staticRenderFns } from "./deckItem.vue?vue&type=template&id=c19fcf82&scoped=true"
import script from "./deckItem.vue?vue&type=script&lang=js"
export * from "./deckItem.vue?vue&type=script&lang=js"
import style0 from "./deckItem.vue?vue&type=style&index=0&id=c19fcf82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19fcf82",
  null
  
)

export default component.exports